import { useState, useEffect } from "react";
import CreateUserForm from "../../../components/create/create-user-form";
import { BASE_URL } from '../../../apiConfig';
import { useAuth } from "../../../context/AuthProvider";
import { useLanguage } from "../../../context/LanguageProvider";
import Loading from "../../../cors/Loading";

export default function CreateUserPage() {
  const { token } = useAuth();
  const { t } = useLanguage();
  const [roles, setRoles] = useState([]);
  const [sellerOptions, setSellerOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        
        if (!token) {
          throw new Error(t('users.no_token'));
        }

        // Fetch roles and sellers in parallel
        const [rolesResponse, sellersResponse] = await Promise.all([
          fetch(`${BASE_URL}/api/role`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
          }),
          fetch(`${BASE_URL}/api/getactivesaller`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: 'application/json',
            },
          })
        ]);

        if (!rolesResponse.ok) {
          throw new Error(t('users.failed_roles'));
        }
        
        if (!sellersResponse.ok) {
          throw new Error(t('users.failed_sellers'));
        }

        const rolesData = await rolesResponse.json();
        const sellersData = await sellersResponse.json();

        setRoles(rolesData.data || []);
        
        // Format sellers for the select component
      
        
        setSellerOptions(sellersData);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>{t('users.error_fetch').replace('{error}', error)}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            {t('users.create_title')}
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            {t('users.create_subtitle')}
          </p>
        </div>

        {/* Form Container */}
        <div className="max-w-3xl mx-auto">
          <CreateUserForm roles={roles} activeSellers={sellerOptions} />
        </div>
      </div>
    </div>
  );
}